import React, { ReactElement } from 'react';
import { Text, View } from 'react-native';
import styled from 'styled-components/native';

import { FillAbsolute, FillAbsoluteCenter } from 'components/Containers';
import { Goals } from 'components/Goals';
import { useGoalsScalingStyles } from 'components/Goals/useGoalsScalingStyles';
import {
  ScalingContext,
  ScalingContextProvider,
} from 'components/ResponsiveLayout';
import { matchesSceneSet } from 'components/Routes/matchesRoutes';
import { useHistory } from 'cross-platform/react-router';

import { FontFamilies } from '../Text/fonts';

export const Container = styled(FillAbsolute)`
  align-items: center;
`;

export const GoalsContainer = (): ReactElement => {
  const goalStyles = useGoalsScalingStyles();
  const history = useHistory();
  const isContent = matchesSceneSet(history);

  return (
    <Container pointerEvents={'none'}>
      <FillAbsoluteCenter>
        <View
          style={{
            position: 'absolute',
            justifyContent: 'center',
            width: goalStyles.containerWidth,
          }}
        >
          <Text
            style={{
              fontSize: goalStyles.sceneTitleFontSize,
              fontFamily: `'${FontFamilies.Bold}'`,
              marginBottom: goalStyles.sceneTitleMarginBottom,
            }}
          >
            Your progress on goals
          </Text>
          <Goals isInSceneSet={isContent} />
        </View>
      </FillAbsoluteCenter>
    </Container>
  );
};

export const GoalsSceneComponent = (): ReactElement => {
  return (
    <ScalingContextProvider scalingContext={ScalingContext.MediaContainer}>
      <GoalsContainer />
    </ScalingContextProvider>
  );
};
